const retailDtUpdate = require('../retail/retail-dt-update')
const timeDate = require('../../../../../js-handler/time-date')

export function organizeRow(data) {
      if (data.length === 0) {
            return [{
                  id: 'nothing',
                  colum: [
                        { label: 'No Results', span: '' },
                        { label: '', span: '' },
                        { label: '', span: '' },
                        { label: '', span: '' },
                  ],
            }]
      }

      return data.map((elem) => {
            const statusPaymentStyle = retailDtUpdate.getStatusPaymentStyle(elem)

            return {
                  id: elem.id,
                  colum: [
                        {
                              label: elem.name || 'Generic customer',
                              span: elem.code,
                              style: {
                                    tdClass: 'tdWithAvatar',
                                    avatar: './css/svg.svg#delete-o',
                                    avatarLetter: '',
                                    svgBg: '#d32f2f',
                              },
                        },
                        { label: `${elem.qty} Units`, span: elem.grand_total_dt },
                        {
                              label: timeDate.friendlyDate(elem.sale_date_td),
                              span: timeDate.friendlyTime(elem.date_registered_time),
                        },
                        {
                              label: statusPaymentStyle.label_top,
                              span: statusPaymentStyle.desc,
                              style: {
                                    tdClass: `tdWithIcon ${statusPaymentStyle.icon.color}`,
                                    svg: `./css/svg.svg#${statusPaymentStyle.icon.svg}`,
                              },
                        },
                  ],
            }
      })
}
